export default __webpack_public_path__ + "static/media/facebook_cover_2.4d5e4f1a.png";